/* global define */
define(["jquery", "../global/templateEngine", "select2"], $ => {
  if ($(".catalogWebProduct").length) {
    $(".siteContainer").prepend(
      '<div class="facetSelector">' +
        '<div class="row">' +
        '<div class="col-6 col-md-3">' +
        '<h2 class="bedrijfsuitjes facetTab"><a href="/">Bedrijfsuitjes</a></h2>' +
        "</div>" +
        '<div class="col-6 col-md-3">' +
        '<h2 class="vergaderen facetTab"><a href="/vergaderen">Vergaderen</a></h2>' +
        "</div>" +
        '<div class="col-6 col-md-3">' +
        '<h2 class="distilleren facetTab"><a href="/restaurant">Restaurant</a></h2>' +
        "</div>" +
        '<div class="col-6 col-md-3">' +
        '<h2 class="kersen facetTab">' +
        '<a href="/whiskystokerij">Whiskystokerij</a>' +
        '</h2>' +
        "</div>" +
        "</div>" +
        "</div>"
    );
  }

  // ///////////////////////////////////////////////////
  // select2
  $(".facetOptions")
    .find("select")
    .each(function each() {
      const $el = $(this);

      $el
        .select2({ allowClear: true, width: "100%" })

        // hack for https://github.com/select2/select2/issues/3320
        .on("select2:unselecting", (/* e */) => {
          $el.data("unselecting", true);
        })
        .on("select2:open", (/* e */) => {
          // note the open event is important
          if ($el.data("unselecting")) {
            $el.removeData("unselecting"); // you need to unset this before close
            $el.select2("close");
          }
        });
    });

  // ///////////////////////////////////////////////////
  // /js/2011/arrangement.js

  $(document).ready(() => {
    $(
      '.specs a[href="#beschikbaarheid"], .buttons .btn[href="#beschikbaarheid"]'
    ).click(e => {
      $('.tabTitle a[href="#beschikbaarheid"]').click();
      return !$(e.target).hasClass("specs");
    });
  });

  // ///////////////////////////////////////////////////
  // /js/facet/main.js

  let timeoutID = null;

  /**
   *
   * @param {String} actionParam
   */
  const updateForm = function updateForm(actionParam) {
    if (timeoutID !== null) {
      clearTimeout(timeoutID);
    }

    $(".buttons img").show();

    const $body = $("body");
    let locationString = $body.hasClass("vergaderen")
      ? "-vergaderen"
      : "-bedrijfsuitjes";
    if ($body.hasClass("events")) {
      locationString = "-events";
    }

    $("#sort").val(
      $("#sortBy")
        .find("option:selected")
        .val()
    );

    const facetContent = $(".facetContent form");
    $.each(facetContent.find("select, input"), function each() {
      if ($(this).attr("name") !== "sort") {
        if (
          $(this).attr("type") !== "submit" &&
          $(this).val() &&
          $(this).val() !== "geen_voorkeur"
        ) {
          locationString += `-${$(this)
            .val()
            .replace(/([-&])/g, "_")}`;
        }
      }
    });

    if (typeof actionParam === "undefined") {
      actionParam = "";
    }

    if (locationString !== "") {
      facetContent.prop(
        "action",
        `/${locationString.substring(1)}${actionParam}`
      );
    }

    timeoutID = setTimeout(
      () => {
        if (facetContent.find(".select2-container--open").length === 0) {
          facetContent.submit();
        } else {
          facetContent
            .find("select")
            .eq(0)
            .change();
        }
      },
      actionParam === "" ? 3000 : 0
    );
  };

  $(document).ready(() => {
    // facet search javascript
    const $facetContentForm = $(".facetContent form");
    if ($facetContentForm.length > 0) {
      $facetContentForm
        .find("select, input")
        .add($("#sortBy"))
        .change(() => {
          updateForm();
        });

      const pagination = $(".pagination a");
      if (pagination.length > 0) {
        pagination.click(function click() {
          $(this).attr(
            "href",
            $(this)
              .attr("href")
              .replace(/sortBy=.[^&]+&?/, "")
          );
        });
      }
    }

    // prevent multiple submit
    $("a.click-once").click(function click() {
      if ($(this).hasClass("click")) {
        return false;
      }
      $(this).addClass("click");
      $(this).css("opacity", 0.5);
      return true;
    });
  });
});
